import { cache } from '@/container/apollo-client/cache';
import { gql } from '@apollo/client';
import { CountTeamsQuery, TeamsInterface } from '@/types/generated/graphql';

const NEW_TEAM_FRAGMENT = gql`
  fragment NewTeam on TeamsInterface {
    id
    name
    description
    status
  }
`;

export function cacheAddTeamV2(node: TeamsInterface) {
  try {
    cache.modify({
      fields: {
        teamsV2(existingTeams = []) {
          const newTeamRef = cache.writeFragment({
            data: node,
            fragment: NEW_TEAM_FRAGMENT,
          });

          return { ...existingTeams, data: [newTeamRef, ...existingTeams.data] };
        },
      },
    });

    cache.modify<CountTeamsQuery>({
      fields: {
        countTeams(existing, { readField, INVALIDATE }) {
          if (!existing) return INVALIDATE;
          const count = readField<number>('count', existing) ?? 0;
          return { ...existing, count: count + 1 };
        },
      },
    });
  } catch (error) {
    console.error('Error adding team to cache:', error);
  }
}

export function cacheUpdateTeamV2(node: TeamsInterface) {
  try {
    cache.writeFragment({
      id: cache.identify(node),
      fragment: NEW_TEAM_FRAGMENT,
      data: node,
    });
  } catch (error) {
    console.error('Error updating team in cache:', error);
  }
}

export function cacheDeleteTeamV2(nodeId: string) {
  try {
    const normalizedId = cache.identify({ id: nodeId, __typename: 'TeamsInterface' });
    cache.evict({ id: normalizedId });
    cache.gc();

    cache.modify({
      fields: {
        countTeams(existing, { readField, INVALIDATE }) {
          if (!existing) return INVALIDATE;

          const currentCount = readField<number>('count', existing) ?? 0;
          const newCount = Math.max(0, currentCount - 1);

          return { ...existing, count: newCount };
        },
      },
    });
  } catch (error) {
    console.error('Error deleting team in cache:', error);
  }
}
